import React from 'react';

const ToggleButton = ({
  value,
  onChange,
  onLabel = 'Oui',
  offLabel = 'Non',
  className = '',
  disabled = false,
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!value);
    }
  };

  return (
    <div className={`toggle-button-container ${className}`}>
      <div
        className={`
          toggle-button 
          ${value ? 'toggle-on' : 'toggle-off'}
          ${disabled ? 'toggle-disabled' : 'cursor-pointer'}
          relative inline-flex items-center w-16 h-10 rounded-full transition-all duration-200 ease-out
          focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-opacity-50
        `}
        onClick={handleToggle}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle();
          }
        }}
      >
        {/* Background */}
        <div
          className={`
          absolute inset-0 rounded-full transition-all duration-200 ease-out
          ${value ? 'bg-blue-500 shadow-sm' : 'bg-gray-200 shadow-inner'}
          ${disabled ? 'opacity-50' : ''}
        `}
        />

        {/* Labels */}
        <div className="absolute inset-0 flex items-center justify-between px-2 text-xs font-semibold">
          <span
            className={`
            z-10 transition-all duration-200 ease-out leading-none
            ${value ? 'text-white opacity-100' : 'text-gray-500 opacity-70'}
          `}
          >
            {onLabel}
          </span>
          <span
            className={`
            z-10 transition-all duration-200 ease-out leading-none
            ${!value ? 'text-white opacity-100' : 'text-gray-500 opacity-70'}
          `}
          >
            {offLabel}
          </span>
        </div>

        {/* Sliding indicator */}
        <div
          className={`
          absolute top-1 w-6 h-8 bg-white rounded-full shadow-lg
          transform transition-transform duration-200 ease-out z-20
          border border-gray-100
          ${value ? 'translate-x-8' : 'translate-x-1'}
        `}
        />
      </div>
    </div>
  );
};

export default ToggleButton;
